import { useMutation, useQueryClient } from '@tanstack/react-query';
import _merge from 'lodash/merge';

import { postUserAccountSuitabilityQuestionnaire } from '@arrived/api_v2';
import { Account, SuitabilityQuestionnaire, SuitabilityQuestionnaireRequest } from '@arrived/models';

import { UseMutationOptions } from '../../queries.utils';
import { accountsPrimaryKeyFn } from '../../users';
import { accountsKeyFn } from '../accounts.keys';

export function usePostSuitabilityQuestionnaireMutation(
  options?: UseMutationOptions<SuitabilityQuestionnaire, SuitabilityQuestionnaireRequest>
) {
  const queryClient = useQueryClient();

  return useMutation((request) => postUserAccountSuitabilityQuestionnaire(request), {
    ...options,
    onSuccess: (data, variables, context) => {
      const account = queryClient.getQueryData<Account | undefined>(accountsKeyFn(data.accountId));
      const primaryAccount = queryClient.getQueryData<Account | undefined>(accountsPrimaryKeyFn());

      if (account) {
        queryClient.setQueryData<Account>(
          accountsKeyFn(data.accountId),
          _merge({}, account, { suitabilityQuestionnaire: data })
        );
      }
      queryClient.invalidateQueries(accountsKeyFn(data.accountId));

      if (primaryAccount?.id === data.accountId) {
        queryClient.setQueryData<Account>(
          accountsPrimaryKeyFn(),
          _merge({}, primaryAccount, { suitabilityQuestionnaire: data })
        );
        queryClient.invalidateQueries(accountsPrimaryKeyFn());
      }

      options?.onSuccess?.(data, variables, context);
    },
  });
}
